export const columns = [
  {
    name: 'id',
    label: '',
    hidden: true,
    sortable: false,
  },
  {
    name: 'transferDate',
    label: 'Transfer Date',
    sortable: false,
  },
  {
    name: 'acceptedIn',
    label: 'Accepted In',
    sortable: false,
  },
  {
    name: 'postingDate',
    label: 'Transaction Posting date',
    sortable: false,
  },
  {
    name: 'beneficiaryAccount',
    label: 'Beneficiary Account',
    sortable: false,
  },
  {
    name: 'amount',
    label: 'Amount',
    sortable: false,
  },
  {
    name: 'currency',
    label: 'Currency',
    sortable: false,
  },
  {
    name: 'paymentType',
    label: 'Payment Type',
    sortable: false,
  },
  {
    name: 'documentNumber',
    label: 'Document #',
    sortable: false,
  },
  {
    name: 'paymentDetails',
    label: 'Payment Details',
    sortable: false,
  },
  {
    name: 'originatorAccountNumber',
    label: 'Originator Account Number',
    sortable: false,
  },
  {
    name: 'originatorFullName',
    label: 'Originator Full Name',
    sortable: false,
  },
  {
    name: 'originatorCountry',
    label: 'Originator Country',
    sortable: false,
  },
  {
    name: 'originatorCity',
    label: 'Originator City',
    sortable: false,
  },
  {
    name: 'originatorAddress',
    label: 'Originator Address',
    sortable: false,
  },
  {
    name: 'originatorsBankBic',
    label: 'Originators Bank BIC',
    sortable: false,
  },
  {
    name: 'originatorsBankSortCode',
    label: 'Originators Bank Sort Code',
    sortable: false,
  },
  {
    name: 'originatorsBankName',
    label: 'Originators Bank Name',
    sortable: false,
  },
  {
    name: 'originatorsCountry',
    label: 'Originators Country',
    sortable: false,
  },
  {
    name: 'originatorsAddress',
    label: 'Originators Address',
    sortable: false,
  },
  {
    name: 'originatorsIntermediaryBankBic',
    label: 'Originators Intermediary Bank BIC',
    sortable: false,
  },
  {
    name: 'originatorsIntermediaryBankCorrespondentAccount',
    label: 'Originators Intermediary Bank Correspondent Account',
    sortable: false,
  },
  {
    name: 'originatorsIntermediaryBankName',
    label: 'Originators Intermediary Bank Name',
    sortable: false,
  },
  {
    name: 'originatorsIntermediaryBankCountry',
    label: 'Originators Intermediary Bank Country',
    sortable: false,
  },
  {
    name: 'originatorsIntermediaryBankAddress',
    label: 'Originators Intermediary Bank Address',
    sortable: false,
  },
];

export const columnsLabels = {};

export const defaultSorter = {};

export const schema = {};

export const filtersSchema = [];
